import PropTypes from 'prop-types';
import Branding from './Branding';
import Contact from './Contact';
import LegalLinks from './LegalLinks';
import Copyright from './Copyright';
import Disclosure from './Disclosure';
import Navigation from './Navigation';

const propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['education', 'election', 'quoting']),
  className: PropTypes.string,
};

function Footer({ children, variant = 'election', className = '' }) {
  const footerClassName = [
    'global__footer',
    variant === 'education' && 'education__footer',
    className,
  ].filter(Boolean).join(' ');

  return (
    <footer className={footerClassName}>
      {children}
    </footer>
  );
}

Footer.propTypes = propTypes;
Footer.Branding = Branding;
Footer.Contact = Contact;
Footer.LegalLinks = LegalLinks;
Footer.Copyright = Copyright;
Footer.Disclosure = Disclosure;
Footer.Navigation = Navigation;

export default Footer;

// Copyright © 2025 Micruity Inc.
